import { TournamentState } from '@ps/web-poker-tile-mappers';
import { millisecondsToSeconds } from 'date-fns';

import { TIME } from '../../constants';
import { DATE_NOW } from '../MTT/time.mock';
import {
  announcedTournament as announcedTournamentBase,
  cancelledTournament as cancelledTournamentBase,
  completedTournament as completedTournamentBase,
  lateRegistrationTournament as lateRegistrationTournamentBase,
  registeringTournament as registeringTournamentBase,
  runningTournament as runningTournamentBase,
  seatingTournament as seatingTournamentBase
} from '../MTT/tournaments.mock';

const { DAY, HOUR, MINUTE, SECOND } = TIME;

export const announcedTournamentBL = {
  ...announcedTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) + 7 * DAY),
  timeClosed: new Date(Date.parse(DATE_NOW) + 14 * DAY).toDateString()
};

export const cancelledTournamentBL = {
  ...cancelledTournamentBase,
  whenStartInt: Number(new Date(Date.parse(DATE_NOW) - 6 * DAY).toDateString())
};

export const completedTournamentBL = {
  ...completedTournamentBase,
  timeClosed: new Date(Date.parse(DATE_NOW) - DAY).toDateString()
};

export const oldCompletedTournamentBL = {
  ...completedTournamentBase,
  id: 3713232942812345,
  timeClosed: new Date(Date.parse(DATE_NOW) - 97 * HOUR).toDateString()
};

export const registeringTournamentBL = {
  ...registeringTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) + MINUTE * 30),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};

export const runningTournamentBL = {
  ...runningTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) - 1 * HOUR),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};

export const pausedTournamentBL = {
  ...runningTournamentBase,
  id: 371326992812345,
  formattedState: TournamentState.PAUSED,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) - 3 * HOUR),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};

export const seatingTournamentBL = {
  ...seatingTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) + SECOND * 30),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};
export const lateRegistrationTournamentBL = {
  ...lateRegistrationTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) - MINUTE * 40),
  regEndInt: millisecondsToSeconds(Date.parse(DATE_NOW) + MINUTE * 20),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};

export const lateRegistrationHourTournamentBL = {
  ...lateRegistrationTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) - MINUTE * 40),
  regEndInt: millisecondsToSeconds(Date.parse(DATE_NOW) + HOUR * 3 + MINUTE * 30),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};

export const lateRegistrationDayTournamentBL = {
  ...lateRegistrationTournamentBase,
  whenStartInt: millisecondsToSeconds(Date.parse(DATE_NOW) - MINUTE * 40),
  regEndInt: millisecondsToSeconds(Date.parse(DATE_NOW) + DAY + MINUTE * 30),
  timeClosed: new Date(Date.parse(DATE_NOW) + 1 * DAY).toDateString()
};

export const tournamentsDataBL = {
  [announcedTournamentBL.id]: announcedTournamentBL,
  [cancelledTournamentBL.id]: cancelledTournamentBL,
  [completedTournamentBL.id]: completedTournamentBL,
  [lateRegistrationTournamentBL.id]: lateRegistrationTournamentBL,
  [pausedTournamentBL.id]: pausedTournamentBL,
  [registeringTournamentBL.id]: registeringTournamentBL,
  [runningTournamentBL.id]: runningTournamentBL,
  [seatingTournamentBL.id]: seatingTournamentBL
};
